import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] bg-white flex items-center justify-center py-20 px-4">
      <SEOHead
        title="403 - Ingen adgang :: KerneViden"
        description="Du har ikke tilladelse til at tilgå denne side."
      />

      <div className="max-w-xl mx-auto text-center space-y-6 bg-white rounded-3xl p-8 sm:p-12 border border-[#E7DFD4] shadow-xs">
        <div className="text-[#C67D5A] mx-auto text-3xl">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>

        <h1 className="font-serif text-3xl sm:text-4xl text-[#233424] font-medium tracking-tight">
          403 - Ingen adgang
        </h1>

        <p className="text-base text-[#526051] leading-relaxed">
          Du har ikke tilladelse til at se denne side eller ressource. Du kan vende trygt tilbage til forsiden.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3.5">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3.5 rounded-full text-sm font-medium text-white bg-[#3A4F3D] hover:bg-[#2C3E2D] shadow-xs transition-colors"
          >
            <i className="fa-solid fa-house text-xs mr-2" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3.5 rounded-full text-sm font-medium text-[#233424] bg-[#EFE9DF] hover:bg-[#E5DDD2] border border-[#D8CFC3] transition-colors"
          >
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
